import styled from '@emotion/styled';

export const FeedbackContainer = styled.div`
  padding: 15px;
  margin-bottom: 15px;
`;
export const FriendsList = styled.ul`
  list-style: none;
  display: flex;
  justify-content: center;
  gap: 20px;
`;
export const FriendsItem = styled.li`
  justify-content: center;
`;
export const FeedbackBtn = styled.button`
padding = 15px;
border-radius = 2px;
font-size: 16px;
  font-weight: 600;
  background-color: #008B8B;
  color: white;
  &:hover {
        background-color: #1E90FF;
        
`;
